<template>
  <div class="login-page">
    <div class="form">
      <div class="company-name">
        <!-- <span id="company-name-1">agent</span>
        <span class="white--text" id="company-name-2">Pay</span> -->
        <v-img 
          class="px-3"
          src="../assets/ownersAppLogoDefault.jpg"
          contain
          height="100"
        ></v-img><span>BETA</span>
      </div>
      <form class="login-form mt-3">
        <!-- <input v-model="username" type="text" placeholder="username"/>
        <input v-model="password" type="password" placeholder="password" v-on:keyup.enter="login"/> -->
        <v-row>
          <v-col cols="12" class="my-0">
            <v-text-field
              outlined
              v-model="username"
              label="Username"
              append-icon="mdi-account"
              light
              class="mb-0 pb-0"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="my-n5">
            <v-text-field
              outlined
              light
              v-model="password"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show ? 'text' : 'password'"
              name="input-10-2"
              label="Password"
              class="input-group--focused"
              @click:append="show = !show"
              @keyup.enter="login"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
          <v-btn
            height="50"
            class="white--text"
            block
            color="#eb5d37"
            @click="login"
            @click.prevent="login"
            :loading="isLoading"
            >
            Log in
            </v-btn>
          </v-col>
        </v-row>

      </form>
      <div v-if="loginError" class="error-msg">
        <p v-if="invalidCredentials" class="caption" style="color:red;">Invalid username or password; please make sure you have entered your details correctly. If you still can't log in, a Client Administrator on your system can reset your password Alternatively, please contact <a class="" href="mailto:support@agentos.com">support@agentos.com</a></p>
        <p v-if="noPermission" class="caption"  style="color:red;">Your user account does not have authorization to view the data contained within this app</p>
        <hr>
            <v-row>
         <v-col cols="12">
          <div class="contact-details" style="color:black;">
            <a class="" href="mailto:support@agentos.com">support@agentos.com</a>
            <p>Call 029 2036 7960</p>
          </div>
         </v-col>
            </v-row>
            <v-row>
          <v-col cols="12">
          <div style="color:black;">
            Opening times: Mon - Fri: 9am - 5pm
            <p>Sat/Sun: closed</p>

          </div>
          </v-col>
            </v-row>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted(){
    this.loginIfAgentOSSessionID();
  },
  data() {
    return {
      btnColor: "#5580ff",
      isLoading: false,
      // username: 'chris.test-letmcletting',
      // password: 'Password111!',
      // username: 'claudio.client-letmcletting',
      // password: 'Password11!',
      username: '',
      password: '',
      loginError: false,
      invalidLoginMsg: '',
      invalidCredentials: false,
      noPermission: false,
      show: false,
    }
  },
  methods: {
    //dispatch $store.action
    login() {
      this.isLoading = true
      this.$store.dispatch('login', {
          username: this.username,
          password: this.password,
      })
      .then( () => {
        this.$router.push('/financials')
        this.isLoading = false
      })
      .catch(err => {
        console.log(Object.values(err))
        if (!err.response) {
          console.log(err);
          this.noPermission = true
        } else {
          this.invalidCredentials = true
          this.password = ''
        }
        this.loginError = true
        this.isLoading = false
      })
    },//login if we are passed a sessionID from AgentOS. If not, do nothing
      loginIfAgentOSSessionID() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        if (urlParams.has('shortname') && urlParams.has('sessionid')){
          this.isLoading = true
          this.$store.dispatch('loginAgentOSSessionID', {
              shortName: urlParams.get('shortname'),
              sessionID: urlParams.get('sessionid'),
          })
          .then( () => {
            this.$router.push('/financials')
            this.isLoading = false
          })
          .catch(err => {
            console.log('Login error: ' + err)
            this.password = ''
            this.isLoading = false
            this.loginError = true
          })
        }
      }
    }
}
</script>

<style scoped>
@import url(https://fonts.googleapis.com/css?family=Roboto:300);
.error-contact-info{
  width:100%;
}
ul li{
  width:100%;
}

.login-page {
  /* border: 2px solid red; */
  min-width: 320px;
  max-width: 360px;
  padding: 0;
  margin: 0 auto 0;
}

.form {
  /* border: 2px solid green; */
  position: relative;
  z-index: 1;
  background:#ffffff;
  border-radius: 10px;
  max-width: 360px;
  margin: 100px auto 100px;
  padding: 20px 20px 40px;
  text-align: center;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
  transition: .3s ease;
}

/* Glow effect (tacky) */
/* .form:hover {
  box-shadow: 0 0 20px 5px rgb(255, 120, 29);
  transition: .3s ease;
} */

.login-form {
  padding: 0 15px;
}

.company-name {
  margin-bottom: 10px;
  font-family: "Roboto", sans-serif;
  font-weight: bold;
}
  #company-name-1 {
    color: rgb(0,0,0,.3);
    font-size: 3rem
  }

  #company-name-2 {
    font-size: 2.8rem;
    border-radius: 18%;
    padding: 6px 5px;
    /* background: #d4d4d4; */
    color: #d4d4d4
  }

/* .form input:focus {
  outline: 3px solid #5580ff;
} */

/* .form input {
  font-family: "Roboto", sans-serif;
  outline: 0;
  background: white;
  width: 100%;
  border: 0;
  margin: 0 0 15px;
  padding: 10px;
  box-sizing: border-box;
  font-size: 14px;
} */

/* .form button {
  font-family: "Roboto", sans-serif;
  outline: 0;
  background: #9d9e9f;
  width: 100%;
  border: 0;
  padding: 5px;
  color: #FFFFFF;
  font-size: 1.3rem;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: pointer;
} */

/* .form button:hover,
.form button:active,
.form button:focus {
  background:#225aff !important;
} */

/* .form button:focus {
  box-shadow: 0 0 20px 0 rgba(43, 46, 250, 0.2), 0 5px 5px 0 rgba(97, 97, 97, 0.24);
  background:#08a51d !important;
}  */

.error-msg {
  margin-top: 1rem;
  color: white;
  font-size: .8rem;
}
  .error-contact-info {
    display: flex;
    margin-top: 1rem;
  }
    #contact-details {
      text-align: left;
    }
    #opening-times {
      list-style-type: none;
      justify-content: start;
    }
    #opening-times-title {
      font-weight: bold;
    }

</style>
